import { apiClient } from '../client/apiClient';
import { ENDPOINTS } from '../config/endpoints';
import type {
  GoogleLoginRequest,
  GoogleLoginResponse,
  RefreshTokenRequest,
  RefreshTokenResponse,
  User,
} from '../types/auth.types';
import type { ApiResponse } from '../types/common.types';

export const authService = {
  googleLogin: (data: GoogleLoginRequest) =>
    apiClient.post<ApiResponse<GoogleLoginResponse>>(ENDPOINTS.AUTH.GOOGLE_LOGIN, data),

  refreshToken: (data: RefreshTokenRequest) =>
    apiClient.post<ApiResponse<RefreshTokenResponse>>(ENDPOINTS.AUTH.REFRESH, data),

  getMe: () => apiClient.get<ApiResponse<User>>(ENDPOINTS.AUTH.ME),
};
